<style scoped>
  #Author{
    width: 900px;
    padding-top: 58px;
    margin:0 auto;
  }
  #Author .title{
    font-size: 24px;
    overflow: hidden;
    padding-bottom: 20px;
    padding-left: 55px;
  }
  #Author .title div{
    float: left;
  }
  #Author .title .radio{
    padding-left: 50px;
    font-size: 18px;

  }
  #Author .title .radio div{
    padding-right: 30px;
    padding-top: 5px;
  }
  #Author .title .radio div label:before{

    margin-top: 5px;
  }
  #Author .title .radio div label:after{
    top:11px;

  }
  #Author .ivu-radio-wrapper{
    font-size: 20px;
  }
  #Author .ivu-form .ivu-form-item-label{
    font-size: 14px;
  }
  #Author .other .add{
    width: 180px;
    height: 40px;
    border: 1px solid #f39800;
    color: #f39800;
margin-top: 20px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  #Author .other table{
    border:1px solid #dddddd;
    table-layout:fixed;word-break:break-all
  }
  #Author .other table th{
    width: 80px;
    padding:10px 10px;
    word-wrap: break-word;
    border-right:1px solid #dddddd;
    border-bottom:1px solid #dddddd;
    text-align:center;
    vertical-align:middle
  }
  .check{
    width: 50px;
    height: 30px;
    display: block;
  }
  #btm{
    width: 200px;
    height:40px;
    background: #141651;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    cursor: pointer;
    margin-top: 50px;
    margin-bottom: 20px;
  }
  .table{
    width: 100%;
  }
  .table ul{
    width: 100%;
    overflow: hidden;
    height: 60px;


  }
  .table ul li{
    float: left;
    height: 100%;
    text-align: center;
    border:1px solid #dddddd;
    border-bottom: 0;
    border-right: 0;
    line-height: 60px;

  }

  .table  .one{
    width: 72px;
  }
  .table ul .two{
    width: 72px;
  }
  .table ul .thr{
    width:135px;
  }
  .table ul .four{
    width: 135px;
  }
  .table ul .five{
    width:414px;
  }
  .table ul .six {
    width: 72px;
  }
  /*.ivu-modal{*/
   /**/
  /*}*/


</style>
<template>
    <div id="Author">
      <div class="title">
        <div>First Author Information</div>
        <div class="radio">
            <div>
              <input class="magic-radio" type="radio" name="radio2" id="5" value="sect" v-model="PreAut" @change="topchange(PreAut)" />
              <label for="5">I am the presenting author</label>
            </div>

        </div>
      </div>

      <div class="ipt">
        <Form ref="formValidate2" :model="formValidate2" :rules="ruleValidate2" :label-width="150">
          <Form-item label="First Name" prop="firstname">
            <Input v-model="formValidate2.firstname" placeholder=""></Input>
          </Form-item>
          <Form-item label="Last Name" prop="lastname">
            <Input v-model="formValidate2.lastname" placeholder=""></Input>
          </Form-item>
          <Form-item label="Department" prop="department">
            <Input v-model="formValidate2.department" placeholder=""></Input>
          </Form-item>
          <Form-item label="Affiliation" prop="affiliation">
            <Input v-model="formValidate2.affiliation" placeholder=""></Input>
          </Form-item>
          <Form-item label="Address" prop="address">
            <Input v-model="formValidate2.address" placeholder=""></Input>
          </Form-item>
          <Form-item label="Post Code" prop="code">
            <Input v-model="formValidate2.code" placeholder=""></Input>
          </Form-item>
          <Form-item label="City" prop="city">
            <Input v-model="formValidate2.city" placeholder=""></Input>
          </Form-item>
          <Form-item label="Country or Region" prop="region">
            <Input v-model="formValidate2.region" placeholder=""></Input>
          </Form-item>
          <Form-item label="Telephone" prop="tel">
            <Input v-model="formValidate2.tel" placeholder=""></Input>
          </Form-item>
          <Form-item label="E-mail" prop="email">
            <Input v-model="formValidate2.email" placeholder=""></Input>
          </Form-item>
          <div class="other">
            <div>Other Authors</div>
            <div>
              <div class="table">

                <table width="900" border="0" cellspacing="0" cellpadding="0">
                  <tr>
                    <th style="width: 72px;">No.</th>
                    <th style="width:96px;">Presenter </th>
                    <th style="width: 135px;">First Name</th>
                    <th style="width: 135px;">Last Name</th>
                    <th style="width: 390px;">Affiliation</th>
                    <th style="width: 72px;"> Delete</th>
                  </tr>

                  <tr v-for="(item,index) in data" :key="index">
                    <th >{{item.No}}</th>
                    <th style="position: relative">
                      <div style="position: absolute;width: 20px; height: 20px;top: 50%; margin-top: -10px;left: 50%;margin-left: -10px">
                        <input class="magic-radio" type="radio" name="radio2" :id="index" :value="item.plid" v-model="PreAut"  @change="change(item.plid)"/>
                        <label :for="index"></label>
                      </div>

                    </th>
                    <th>
                      {{item.firstname}}
                    </th>
                    <th>{{item.lastname}}</th>
                    <th>{{item.aff}}</th>
                    <th style="color:#f39800; font-size: 20px" @click="delblock(index)"> <Icon style='cursor: pointer' type="close-round"></Icon></th>
                    <Modal v-model="delmodl" width="360" :styles="{top: '200px'}">
                      <p slot="header" style="color:#f60;text-align:center">
                        <Icon type="information-circled"></Icon>
                        <span>delete</span>
                      </p>
                      <div style="text-align:center">
                        <p>Confirm to delete?</p>

                      </div>
                      <div slot="footer">
                        <Button type="error" size="large" long :loading="modal_loading" @click="del">delete</Button>
                      </div>
                    </Modal>
                  </tr>
                </table>

              </div>
              <div class="add" @click="modublock">Add Authors</div>
            </div>

            <Modal v-model="addAuth" width="700">
              <p slot="header" style="color:#000;text-align:center">
                <Icon type="plus-round"></Icon>
                <span>Add Authors</span>
              </p>
              <div>
                <Form ref="formValidate5" :model="formValidate5" :rules="ruleValidate5" :label-width="110">
                  <Form-item label="First Name" prop="firstname">
                    <Input v-model="formValidate5.firstname" placeholder=""></Input>
                  </Form-item>
                  <Form-item label="Last Name" prop="lastname">
                    <Input v-model="formValidate5.lastname" placeholder=""></Input>
                  </Form-item>
                  </Form-item>
                  <Form-item label="Affiliation" prop="Affil">
                    <Input v-model="formValidate5.Affil" placeholder=""></Input>
                  </Form-item>
                  </Form-item>




                </Form>
              </div>
              <div slot="footer">
                <Button type="info" size="large" long @click="addpreaut('formValidate5')">add</Button>
              </div>
            </Modal>


          </div>

             <div id="btm" @click="addupdatalink('formValidate2')">Save and Next</div>

          </Form-item>
        </Form>
      </div>



    </div>
</template>

<script>
  import Bus from '@/bus'
  import check from 'magic-check/css/magic-check.css'
  import  'iview/src/styles/common/iconfont/fonts/ionicons.eot'
  import 'iview/src/styles/common/iconfont/fonts/ionicons.svg'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.ttf'
  import   'iview/src/styles/common/iconfont/fonts/ionicons.woff'
    export default{
        data(){
            return {
              delmodl:false,
              modal_loading: false,
              paperid:'',
              firstAut:'',
              PreAut:'',
              addAuth:false,
              formValidate5:{
                firstname:'',
                lastname:'',
                Affil:''

              },
              ruleValidate5:{
                firstname: [
                  { required: true, message: 'Please input first name', trigger: 'blur' }
                ],
                lastname: [
                  { required: true, message: 'Please input last name', trigger: 'blur' }
                ],
                Affil: [
                  { required: true, message: 'Please input affiliation', trigger: 'blur' }
                ],
              },
              formValidate2:{
                plFirstFl:'',
                firstname:'',
                lastname:'',
                department:'',
                affiliation:'',
                address:'',
                code:'',
                city:'',
                region:'',
                tel:'',
                email:'',
                plid:''

              },
              ruleValidate2: {
                firstname: [
                  { required: true, message: 'Please input first name', trigger: 'blur' }
                ],
                lastname: [
                  { required: true, message: 'Please input last name', trigger: 'blur' }
                ],
                department: [
                  { required: true, message: 'Please input department', trigger: 'blur' }
                ],
                affiliation: [
                  { required: true, message: 'Please input affiliation', trigger: 'blur' }
                ],
                address: [
                  { required: true, message: 'Please input address', trigger: 'blur' }
                ],
                code: [
                  { required: true, message: 'Please input post code', trigger: 'blur' },
//                  { type: 'number', message: '邮箱格式不正确', trigger: 'blur' }
                ],
                city: [
                  { required: true, message: 'Please input city', trigger: 'blur' }
                ],
                region: [
                  { required: true, message: 'Please input country or region', trigger: 'blur' }
                ],
                tel: [
                  { required: true, message: 'Please input telephone', trigger: 'blur' },
                ],
                email: [
                  { required: true, message: 'Please input e-mail', trigger: 'blur' },
                  { type: 'email', message: 'Invalid e-mail', trigger: 'blur' }
                ],

              },
              data:[
//                {
//                    No:1,
//                    firstname:'fdfdsfsafsafdasfdas afasd ',
//                    lastname:'fsdfa ',
//                    aff:'fsdf ',
//                },


              ],
            }
        },
        mounted(){
          this.paperid=localStorage.getItem('paperId');
          if(this.paperid!=0){
            this.addinfo();
          }




        },
        methods: {
            //删除提示框显示
          delblock(index){
              sessionStorage.setItem('delindex',index);
              this.delmodl=true;
          },
          topchange(index){
              this.Present()
          },
          change(index){
            this.Present()
          },
            //删除第二作者
          del(){

              var index = sessionStorage.getItem('delindex');
              this.modal_loading = true;
            setTimeout(() => {
              var param = {

                'plid':this.data[index].plid,   //论文id   修改时候传入，添加为空
              }


              this.postHttp('/medapp/api/paper//paperlink/delete', param).then((result) => {
                let  data=result.data;
                if (result.data.code == '0') {
                  this.modal_loading = false;
                  this.delmodl = false;
                  this.$Message.success('Successfully deleted ');
                    this.data.splice(index,1)

                } else{
                  console.log(data.code);

                }
              });

            }, 1000);


          },

          Present(){
            var plid
              if(this.PreAut=='sect'){
                plid=this.formValidate2.plid;
              }else{
                plid=this.PreAut;
              }
              var param = {
                'is_present':1,   //是否发言人
                'plid':plid,   //论文id   修改时候传入，添加为空
                'paperid':this.paperid,   //论文id   修改时候传入，添加为空
              }

              this.postHttp('/medapp/api/paper/addorupdatepaperlink', param).then((result) => {
                let  data=result.data;
                if (result.data.code == '0') {



                } else{
                  console.log(data.code);

                }
              });
            },

            addupdatalink(name){

              this.$refs[name].validate((valid) => {
                if (valid) {
                  if(this.firstAut=='first'){
                    this.firstAut=1;
                  }else{
                    this.firstAut=0;
                  }
                  if(this.PreAut=='sect'){
                    this.PreAut=1;
                  }else{
                    this.PreAut=0;
                  }
                    var param = {
                      'paperid':this.paperid,   //论文id   修改时候传入，添加为空
                      'is_first':1,   //是否第一作者 0:否  1:是
                      'is_present':this.PreAut,   //是否发言人
                      'order':'0',   //顺序   1 2 3 4
                      'plid':this.formValidate2.plid,   //关联id 修改不为空 ，添加为空
                      'cid  ':'2006',      //会议id
                      'name':'',      //名字
                      'phone':this.formValidate2.tel,      //手机 电话
                      'org':this.formValidate2.affiliation ,     //单位
                      'dept':this.formValidate2.department,      //部门
                      'email':this.formValidate2.email,      //电子邮箱
                      'country':this.formValidate2.region,     //国家
                      'postcode':this.formValidate2.code,    //  邮政编码
                      'firstpy': this.formValidate2.firstname,//  外国人名
                      'lastpy': this.formValidate2.lastname ,//外国人姓氏
                      'province':'',//省
                      'addr': this.formValidate2.address,//通信地址
                      'language': 'en',// 中文英文   英文en  中文 cn
                      'city': this.formValidate2.city,//城市
                    }



                  this.postHttp('/medapp/api/paper/addorupdatepaperlink', param).then((result) => {

                    let  data=result.data;
                    if (result.data.code == '0') {
                      Bus.$emit('button',3)
                      this.$router.push('/home_en/2006/submit/Preview')

                    } else{
                      console.log(data.code);
//                    this.$Message.error('error!');
                    }
                  });

                } else {
//                this.$Message.error('表单验证失败!');
                }
              })

            },
          //添加第二作者弹窗
          modublock(){
                this.addAuth=true;
                this.formValidate5.firstname='';
               this.formValidate5.lastname='';
               this.formValidate5.Affil='';
          },

          //添加作者列表调用接口
          addinfo(){
            var param = {
              'paperid':this.paperid,  //论文id   修改时候传入，添加为空

            }
            this.postHttp('/medapp/api/paper/getpapersinfo', param).then((result) => {
                let  data=result.data;
                console.log(JSON.stringify(data))
                if (result.data.code == '0') {
                  for(let i=1;i<data.paper.links.length; i++){
                    this.data.push({
                      plid:data.paper.links[i].plId,
                      No:data.paper.links[i].plOrder,
                      firstname:data.paper.links[i].author.uFirstPy,
                      lastname:data.paper.links[i].author.uLastPy,
                      aff:data.paper.links[i].author.uOrg
                    })
                  }
                  if (data.paper.links.length>0){
                    if(data.paper.links[0].plPresentFl==1){
                      this.PreAut='sect';
                    }else{
                        for(var i=1;i<data.paper.links.length;i++){
                            if(data.paper.links[i].plPresentFl=='1'){
                              this.PreAut=data.paper.links[i].plId
                            }
                        }
                    }
                      this.formValidate2.plFirstFl=data.paper.links[0].plFirstFl
                      this.formValidate2.plid=data.paper.links[0].plId;
                      this.formValidate2.tel=data.paper.links[0].author.uPhone;
                      this.formValidate2.email=data.paper.links[0].author.uEmail
                      this.formValidate2.department=data.paper.links[0].author.uDept
                      this.formValidate2.address=data.paper.links[0].author.uAddr
                      this.formValidate2.affiliation=data.paper.links[0].author.uOrg
                      this.formValidate2.lastname=data.paper.links[0].author.uLastPy
                      this.formValidate2.firstname=data.paper.links[0].author.uFirstPy
                      this.formValidate2.code=data.paper.links[0].author.uPostcode
                      this.formValidate2.region=data.paper.links[0].author.uCountry
                      this.formValidate2.city=data.paper.links[0].author.uCity


                  }else{

                      this.formValidate2.tel=data.paperUser.uPhone;
                      this.formValidate2.email=data.paperUser.uEmail
                      this.formValidate2.department=data.paperUser.uDept
                      this.formValidate2.address=data.paperUser.uAddr
                      this.formValidate2.affiliation=data.paperUser.uOrg
                      this.formValidate2.lastname=data.paperUser.uLastPy
                      this.formValidate2.firstname=data.paperUser.uFirstPy
                      this.formValidate2.code=data.paperUser.uPostcode
                      this.formValidate2.region=data.paperUser.uCountry
                      this.formValidate2.city=data.paperUser.uCity
                    }



                } else{
                  console.log(data.code)
                }

          })
          },

          //添加第二作者
          addpreaut(name){
//              this.data=[];
            this.$refs[name].validate((valid) => {
              if (valid) {
                if(this.firstAut=='first'){
                  this.firstAut=1;
                }else{
                  this.firstAut=0;
                }

                  var param = {
                    'paperid':this.paperid,  //论文id   修改时候传入，添加为空
                    'firstpy': this.formValidate5.firstname,//  外国人名
                    'lastpy': this.formValidate5.lastname ,//外国人姓氏
                    'org':this.formValidate5.Affil,
                    'is_first':0,   //是否第一作者 0:否  1:是
//                    'is_present':1,

                  }

                this.postHttp('/medapp/api/paper/addorupdatepaperlink', param).then((result) => {
                  let  data=result.data;
                  if (result.data.code == '0') {
//                      for(let i=0;i<data.paper.links.length; i++){
                          this.data.push({
                            plid:data.paperlink.plId,
                            No:data.paperlink.plOrder,
                            firstname:data.paperlink.author.uFirstPy,
                            lastname:data.paperlink.author.uLastPy,
                            aff:data.paperlink.author.uOrg
                          })
//                      }


//                    this.$Message.success('提交成功!');
                    this.addAuth=false;

                  } else{
                    console.log(data.code)
//                    this.$Message.error('提交失败!');
                  }


                });

              } else {
                this.addAuth=true;
                this.$Message.error('信息不完善!');
              }
            })

          }
        }

    }

</script>



// WEBPACK FOOTER //
// AuthorsInfo.vue?349b4e4e